import React, { Component } from 'react';

class SubmitFeedRequest extends Component {

    render() {
        const { onBack, loading, onSubmit,hideBtn, disabled} = this.props;
        return <div className="hideforBSearch">
            <button type="button" className="btn btn-secondary" onClick={onBack}>Back</button>
            {!hideBtn && <span className="create_feed_hideshow">
                <button disabled={loading ? 'disabled' : null} type="button" className={`btn btn-primary ${loading ? 'spinner spinner-right disabled' : ''} ms-2`} id="create_feed" onClick={onSubmit}>Create Feed</button>
            </span>}
        </div>
    }
}

export default SubmitFeedRequest;